
const sortArrayRemoveDuplicates = (array, comparator = (a, b) => a - b) => 
    array
        .toSorted( comparator )
        .reduce((prev,curr) => (0 < prev.length && 0 === comparator( prev[prev.length-1], curr))? prev: [...prev, curr], []);

export default sortArrayRemoveDuplicates;